import { useEffect } from "react";

import type { ToolNameType } from "../tools/types";

import { useAppDispatch } from "store/index";
import { aiStateActions } from "store/slices/ai";
import { isAIChatToolsEnabled } from "utils/waffle-flags";

/**
 * This hook registers a tool call for the AI assistant, related to the current component.
 * For as long as the component is mounted. The AI assistant will potentially call the tool
 * when it thinks it's appropriate, based on the user's chat history and input.
 *
 * Be sure to memoize the data being passed in.
 */
export const useAITool = <Name extends ToolNameType>(toolName: Name, allowed: boolean = true) => {
  const dispatch = useAppDispatch();
  const enabled = isAIChatToolsEnabled();

  useEffect(() => {
    if (enabled && allowed) {
      dispatch(aiStateActions.addTool(toolName));
    } else {
      dispatch(aiStateActions.removeTool(toolName));
    }
    return () => {
      dispatch(aiStateActions.removeTool(toolName));
    };
  }, [dispatch, toolName, enabled, allowed]);
};
